import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Checkbox as AntCheckbox } from 'antd';

export const SCheckbox = styled(AntCheckbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    ${(props): any =>
      !props.disabled &&
      !props.indeterminate &&
      css`
        background-color: #1890ff;
        border-color: #1890ff;
      `}
  }
`;
